import React from 'react';
import classNames from 'classnames';
import {route} from "~/app/helpers/route";
import Icon from '~/app/common/Icon';
import {useStoreState} from '~/store';
import {Machine, Project} from '~/types';
import classes from './style.module.scss';
import LinkWrapper from "~/app/common/LinkWrapper";
import {MACHINES_ROUTES} from "~/machines/Router";
import {useParams} from "react-router-dom";
import {formatInternWithDriver} from "~/machines/helpers";

export interface ListItemProps {
    item: Machine
}

export type ListItemComponent = React.FC<ListItemProps>

const ListItem: ListItemComponent = ({item}) => {
    const inFavorite = useStoreState(state => state.machines.inFavorite(item.id));
    const {projectId} = useParams<{ projectId: Project['id'] }>();

    return (
        <LinkWrapper className={classes['list-item']} to={route(MACHINES_ROUTES.details, {projectId, id: item.id})}>
            <div className={classes['category-image']}>
                <img src={item.categoryImage} alt={''}/>
            </div>
            <div className={classes['info']}>
                <div className={classes['name']}>{item.name}</div>
                <div className={classes['code']}>{formatInternWithDriver(item)}</div>
            </div>

            <div className={classNames(classes['favorite-wrap'], {[classes['in-favorite']]: inFavorite})}>
                {
                    inFavorite
                        ? <Icon name={inFavorite ? 'star' : 'star_border'}/>
                        : ''
                }
            </div>
        </LinkWrapper>
    );
};

export default ListItem
